<template>
	<div>
		<TitleSection :class="{'logo': true, 'logo--loaded': isPageLoaded }">
			<template #h1>
				<img src="~/assets/media/i/mailuft.webp" alt="Mailuft - Software-Entwicklung aus Wien, Coding, Projekte" width="510" height="132" />
			</template>
			<template #h2>
				Software, neu gedacht.
			</template>
			<template #menu>
				<NuxtLink to="/about/" aria-label="Erfahren Sie mehr über uns">Mehr über uns</NuxtLink>
			</template>
		</TitleSection>
	</div>
</template>

<script setup lang="ts">
const isPageLoaded = ref(false)

useSeoMeta({
	title: 'Mailuft - Software, neu gedacht - Software-Entwicklung aus Wien',
	ogTitle: 'Mailuft - Software, neu gedacht',
	twitterTitle: 'Mailuft - Software, neu gedacht',
	ogDescription: 'Software, neu gedacht. Seit 2016 entwickeln wir maßgeschneiderte Softwarelösungen, die neue Maßstäbe setzen.',
	description: 'Software, neu gedacht. Seit 2016 entwickeln wir maßgeschneiderte Softwarelösungen, die neue Maßstäbe setzen.',
	twitterDescription: 'Software, neu gedacht. Seit 2016 entwickeln wir maßgeschneiderte Softwarelösungen, die neue Maßstäbe setzen.',
})

onMounted(() =>
{
	isPageLoaded.value = true
})
</script>

<style lang="css" scoped>
div
{
	position: relative;
}

.logo
{
	opacity: 0;
	filter: blur(50px);
	transition: opacity 1s ease-in, filter 1s ease-out;
}

.logo img
{
	width: 100%;
	max-width: 510px;
	height: auto;
}

.logo--loaded
{
	filter: blur(0);
	opacity: 1;
}


</style>